<template>
    <nav class="nav-extended cyan lighten-2" v-show="user">
        <div class="nav-wrapper" style="margin:0 20px 0 20px;">
            <!-- <a href="#" class="brand-logo">Logo</a> -->
            <a href="#" data-target="mobile-side" class="sidenav-trigger">
                <i class="material-icons">menu</i>
            </a>
            <router-link to="/" class="brand-logo" tag="a">OneHealthApp</router-link>

            <ul id="nav-mobile" class="right hide-on-med-and-down">
                <li v-show="!user">
                    <router-link to="/login">Login</router-link>
                </li>
                 <li v-show="user">
                    <router-link to="/home">Home</router-link>
                </li>
                <li v-if="type === 'admin'">
                    <router-link to="/merchants">Merchants</router-link>
                </li>
                 <li v-show="user">
                    <router-link to="/list">Customers</router-link>
                </li>
                <!-- <li v-show="user">
                    <router-link to="/create">Create</router-link>
                </li>
                <li v-show="user">
                    <router-link to="/todo">To Do</router-link>
                </li> -->
                <li v-show="user">
                    <router-link to="/profile">Profile</router-link>
                </li>
                <li v-show="user">
                    <a @click="signoutButtonPressed">Logout</a>
                </li>
            </ul>
        </div>
        <transition name="slide-fade">
            <div v-if="showSearch" class="nav-content">
                <div class="nav-wrapper">
                    <form @submit.prevent="doSearch" style="height:64px">
                        <div class="input-field">
                            <input
                                id="search"
                                v-model="searchTerm"
                                placeholder="Search for Users or Apps"
                                type="search"
                            />
                            <label class="label-icon" for="search">
                                <i class="material-icons">search</i>
                            </label>
                            <i class="material-icons">close</i>
                        </div>
                    </form>
                </div>
            </div>
        </transition>
        <ul class="sidenav" id="mobile-side">
            <li v-show="!user">
                    <router-link to="/login">Login</router-link>
                </li>
                <li v-show="user">
                    <router-link to="/home">Home</router-link>
                </li>
                <li v-if="type === 'admin'">
                    <router-link to="/merchants">Merchants</router-link>
                </li>
                <li v-show="user">
                    <router-link to="/list">Customers</router-link>
                </li>
                <li v-show="user">
                    <router-link to="/profile">Profile</router-link>
                </li>
                <li v-show="user">
                    <a @click="signoutButtonPressed">Logout</a>
                </li>
        </ul>
    </nav>
</template>

<script>
import 'materialize-css/dist/css/materialize.css'
import firebase from "firebase";
export default {
    data() {
        return {
            user: null,
            showSearch: false,
            searchTerm: "",
            type:"merchant"
        };
    },
    mounted() {
        var elems = document.querySelectorAll(".dropdown-trigger");
        if (elems) {
            this.$M.Dropdown.init(elems, {
                constrainWidth: false
            });
        }
        this.$M.Sidenav.init(document.querySelectorAll(".sidenav"), {});
        $(".button-collapse").off('click').sideNav({
                closeOnClick: true });
    },
    created() {
        const vm = this;
        firebase.auth().onAuthStateChanged(user => {
            this.user = user;
            if(user){
                user.getIdTokenResult()
                .then((idTokenResult) => {
                    vm.type = idTokenResult.claims.type;
                    // console.log("type user "+ vm.type);
                })
                .catch((error) => {
                    // console.log(error);
                });
                // const cityRef = firebase.firestore().collection('merchants').doc(user.uid);
                // cityRef.get().then(function(doc) {
                //     if (doc.exists) {
                //         vm.type = doc.data().type;
                //     } 
                // }).catch(function(error) {
                //     console.log("Error getting document:", error);
                // });
            }
        });
    },
    methods: {
        signoutButtonPressed(e) {
            e.stopPropagation();
            firebase.auth().signOut();
            this.$router.push({ name: "Login" });
        }
    }
};
</script>
<style lang="sass" scoped>
    @import url(https://fonts.googleapis.com/icon?family=Material+Icons)
    @import url(https://fonts.googleapis.com/css?family=Cinzel:700&display=swap)



    .brand-logo
        font-family: 'Georgia', serif

    .slide-fade-enter-active 
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)

    .slide-fade-leave-active 
        transition: all .3s ease

    .slide-fade-enter, .slide-fade-leave-to
        transform: translateY(-10px)
        opacity: 0

    

    .sidenav-overlay 
         background-color: transparent
         
    
</style>



